export interface Version {
  engine: string;
  build: string;
}

export type VersionAction = 'current' | 'wait' | 'reload' | 'invalid';
declare const __CLIENT_VERSION__: Version;

/** Decide whether the connected deployment can accept this client's commands. */
export function versionAction(server: unknown, phase: string, client: Version = __CLIENT_VERSION__): VersionAction {
  if (!server || typeof server !== 'object' || !('engine' in server) || !('build' in server)) return 'invalid';
  if (typeof server.engine !== 'string' || !server.engine.trim() || typeof server.build !== 'string' || !server.build.trim()) return 'invalid';
  if (server.engine === client.engine && server.build === client.build) return 'current';
  return ['SETUP', 'LOG', 'DEBRIEF', 'ENDED'].includes(phase) ? 'reload' : 'wait';
}
